import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import IconMail from '../../images/common/icon_mail.png';
import IconMail2x from '../../images/common/icon_mail@2x.png';
import { AuthUserContextType, useAuthUserContext } from '../../providers';
import { toast } from 'react-toastify';
import Spinner from '../../components/Spinner';

type CustomLocation = {
  state: { from: { pathname: string } }
};

const Email = () => {
  const [ email, setEmail ] = useState("");
  const [ password, setPassword ] = useState("");
  const [ loading, setLoading ] = useState(false);

  const navigate = useNavigate();
  const location: CustomLocation = useLocation() as CustomLocation;
  const fromPathName: string = location.state ? location.state.from.pathname : '/mypage';
  const authUser: AuthUserContextType = useAuthUserContext();

  const validateInput = () => {
    const regEmail = /^[a-zA-Z0-9_+-]+(.[a-zA-Z0-9_+-]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$/;
    const regPassword = /^[\x21-\x7E]{8,100}$/;

    return regEmail.test(email) && regPassword.test(password);
  }

  const signin = () => {
    if (!validateInput()) {
      toast.error("メールアドレスまたはパスワードが間違っています。");
      return;
    }

    setLoading(true);
    authUser.signin(
      { email: email, password: password },
      () => {
        setLoading(false);
        toast.success("ログインしました。");
        navigate(fromPathName, { replace: true })
      },
      () => {
        setLoading(false);
        toast.error("メールアドレスまたはパスワードが間違っています。");
      });
  }

  return (
    <section>
      <h2 className="curve_title">
        <img
          src={ IconMail }
          srcSet={ `${ IconMail } 1x, ${ IconMail2x } 2x` }
          alt="メールアドレスでログイン"
        />
        メールアドレスでログイン
      </h2>
      <div className="form">
        <dl className="graf_list">
          <dt>メールアドレス</dt>
          <dd>
            <input
              type="email"
              value={ email }
              onChange={ e => setEmail(e.target.value) }
              onKeyUp={ e => e.key === 'Enter' && validateInput() && signin() }
              placeholder="メールアドレス"
            />
          </dd>
          <dt>パスワード</dt>
          <dd>
            <input
              type="password"
              value={ password }
              onChange={ e => setPassword(e.target.value) }
              onKeyUp={ e => e.key === 'Enter' && validateInput() && signin() }
              placeholder="パスワード"
            />
            <p>パスワードを忘れた方は<Link to ="/password/forgot">こちら</Link></p>
          </dd>
        </dl>
        <button
          className="w_bluebtn"
          type="submit"
          onClick={ () => signin() }
          disabled={ loading }
        >
          { loading ? <Spinner size="small" /> : 'ログイン' }
        </button>
      </div>
    </section>
  );
}

export default Email;
